<template>
    <form @submit.prevent="submit">
        <div class="flex flex-wrap">
            <div class="w-full lg:w-1/2 px-2">
                <card>
                    <template slot="header">
                        Message
                    </template>

                    <div class="p-8 flex flex-wrap">
                        <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-4 w-full"
                                    label="Message name"/>

                        <text-input v-model="form.from_name" :error="form.errors.from_name" class="pr-6 pb-4 w-full"
                                    label="From name"/>

                        <text-input v-model="form.reply_to" :error="form.errors.reply_to" type="email"
                                    class="pr-6 pb-4 w-full"
                                    label="Reply to"/>

                        <checkbox-group v-model="form.to_fields" :entries="ADDRESS_FIELDS" :errors="form.errors.to_fields"
                                        label="To" class="pr-6 pb-4 w-full">
                        </checkbox-group>

                        <checkbox-group v-model="form.cc_fields" :entries="ADDRESS_FIELDS" :errors="form.errors.cc_fields"
                                        label="Cc" class="pr-6 pb-4 w-full">
                        </checkbox-group>

                        <checkbox-group v-model="form.bcc_fields" :entries="ADDRESS_FIELDS"
                                        :errors="form.errors.bcc_fields" label="Bcc" class="pr-6 pb-4 w-full">
                        </checkbox-group>

                        <text-input v-model="form.subject" :error="form.errors.subject" class="pr-6 pb-4 w-full"
                                    label="Subject"/>

                        <textarea-input v-model="form.message_body" :error="form.errors.message_body" class="pr-6 pb-4 w-full"
                                        label="Message">
                        </textarea-input>

                        <file-input v-model="form.attachment_template" :error="form.errors.attachment_template"
                                    class="pr-6 pb-2 w-full" type="file" label="Attachment template"/>
<!--                        <a v-if="uploads.attachment_template" class="text-indigo-400 hover:text-indigo-600"-->
<!--                           :href="route('download-media.show', uploads.attachment_template.uuid)"-->
<!--                           download>{{ uploads.attachment_template.file_name }}</a>-->

                        <checkbox-input v-model="form.attachment_encrypt_file" :error="form.errors.attachment_encrypt_file"
                                        class="pr-6 pb-4 w-full" label="Encrypt attachment"/>

                        <text-input v-model="form.attachment_open_password" v-show="form.attachment_encrypt_file"
                                    :error="form.errors.attachment_open_password" class="pr-6 pb-4 w-full"
                                    label="Attachment open password"/>

                        <checkbox-input v-model="form.attachment_restrict_permissions" :error="form.errors.attachment_restrict_permissions"
                                        class="pr-6 pb-4 w-full" label="Restrict attachment permissions"/>

                        <text-input v-model="form.attachment_permission_password" v-show="form.attachment_restrict_permissions"
                                    :error="form.errors.attachment_permission_password" class="pr-6 pb-4 w-full"
                                    label="Attachment permission password"/>

                        <select-input v-model="form.attachment_restrict_printing" v-show="form.attachment_restrict_permissions"
                                      :error="form.errors.attachment_restrict_printing"
                                      label="Restrict attachment printing" class="pr-6 pb-4 w-full">
                            <option v-for="opt in PDF_PRINT_PERMISSION_ENUM" :value="opt.value" v-text="opt.label"></option>
                        </select-input>

                        <select-input v-model="form.attachment_restrict_changes" v-show="form.attachment_restrict_permissions"
                                      :error="form.errors.attachment_restrict_changes"
                                      label="Restrict attachment changes" class="pr-6 pb-4 w-full">
                            <option v-for="opt in PDF_CHANGE_PERMISSION_ENUM" :value="opt.value" v-text="opt.label"></option>
                        </select-input>


                        <checkbox-input v-model="form.attachment_enable_content_copying" v-show="form.attachment_restrict_permissions"
                                        :error="form.errors.attachment_enable_content_copying"
                                        class="pr-6 pb-4 w-full" label="Allow content copying"/>

                        <select-input v-model="form.response_date_reference" :error="form.errors.response_date_reference"
                                      label="Response date reference" class="pr-6 pb-4 w-full">
                            <option v-for="opt in RESPONSE_DATE_REFERENCE_ENUM" :value="opt.value" v-text="opt.label"></option>
                        </select-input>

                        <text-input v-model="form.response_days" :error="form.errors.response_days"
                                    v-show="form.response_date_reference === 'relative'" type="number"
                                    class="pr-6 pb-4 w-full"
                                    label="Reponse days"/>

                        <date-input v-model="form.response_date" :error="form.errors.response_date"
                                    v-show="form.response_date_reference === 'fixed'" class="pr-6 pb-4 w-full"
                                    label="Response date"></date-input>


                        <checkbox-group v-model="form.update_date_fields" :error="form.errors.update_date_fields" :entries="DATE_FIELDS"
                                        label="Dates to update" class="pr-6 pb-4 w-full">
                        </checkbox-group>
                    </div>

                    <template slot="footer">
                        <button v-if="id != null" @click="destroy" class="btn-red" tabindex="-1" type="button">
                            Delete Message
                        </button>
                        <loading-button v-if="id == null" :loading="form.processing" class="btn-indigo ml-auto"
                                        type="submit">
                            Create Message
                        </loading-button>
                        <loading-button v-else :loading="form.processing" class="btn-indigo ml-auto" type="submit">
                            Update Message
                        </loading-button>
                    </template>
                </card>
            </div>

            <div class="w-full lg:w-1/2 px-2">
                <card class="">
                    <template slot="header">
                        Template processing
                    </template>
                    <div class="p-8 flex flex-wrap max-h-svh overflow-y-scroll">
                        <p class="pb-4">
                            Template processing allows messages to be personalized to the recipient by replacing macros with field values.
                            These macros can be used in the message body and attachment template fields.
                        </p>
                        <p class="pb-4">
                            Macros use the following format: ${field_name}.
                        </p>
                        <p class="pb-4">
                            For example, "Hello ${contact.given_name} ${contact.surname}!" would be processed to become "Hello John Doe!"
                        </p>
                        <p class="pb-4 font-semibold">
                            Recognized macros:
                        </p>
                        <ul v-for="group in fieldGroups" :label="group.label" :key="group.label" class="w-full">
                            <li v-for="field in group.fields" :key="field" class="list-disc list-inside" v-text="'${' + field + '}'">
                            </li>
                        </ul>
                    </div>
                </card>
            </div>


        </div>
    </form>
</template>

<script>
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import FileInput from '@/Shared/FileInput'
import LoadingButton from '@/Shared/LoadingButton'
import Card from '@/Shared/Card/Card'
import CardListItem from '@/Shared/Card/CardListItem'
import Icon from '@/Shared/Icon'
import TextareaInput from "../../../Shared/TextareaInput.vue";
import CheckboxGroup from "../../../Shared/CheckboxGroup.vue";
import DateInput from "../../../Shared/DateInput.vue";
import {
    MessageEmailFieldEnum,
    MessageUpdateDateFieldEnum,
    PdfChangePermissionEnum,
    PdfPrintPermissionEnum,
    ResponseDateReferenceEnum
} from "../../../Enums/Enums";
import CheckboxInput from "../../../Shared/CheckboxInput.vue";

export default {
    components: {
        CheckboxInput,
        DateInput,
        TextareaInput,
        Card,
        CardListItem,
        TextInput,
        SelectInput,
        FileInput,
        LoadingButton,
        CheckboxGroup,
        Icon,
    },
    props: {
        eventInfo: Object,
        id: Number,
        name: { type: String, default: '' },
        from_name: { type: String, default: '' },
        reply_to: { type: String, default: '' },
        to_fields: { type: Array, default: () => [] },
        cc_fields: { type: Array, default: () => [] },
        bcc_fields: { type: Array, default: () => [] },
        subject: { type: String, default: '' },
        uploads: { type: Object, default: () => {} },
        message_body: { type: String, default: '' },
        update_date_fields: { type: Array, default: () => [] },
        response_date_reference: { type: String, default: '' },
        response_days: { type: Number, default: 0 },
        response_date: { type: Date, default: null },
        attachment_encrypt_file: { type: Boolean, default: false },
        attachment_open_password: { type: String, default: '' },
        attachment_restrict_permissions: { type: Boolean, default: false },
        attachment_permission_password: { type: String, default: '' },
        attachment_restrict_printing: { type: Number, default: 2 },
        attachment_restrict_changes: { type: Number, default: 4 },
        attachment_enable_content_copying: { type: Boolean, default: true },
        fieldGroups: Array,
    },
    data() {
        return {
            form: this.$inertia.form({
                _method: this.id == null ? 'post' : 'put',
                name: this.name,
                from_name: this.from_name,
                reply_to: this.reply_to,
                to_fields: this.to_fields,
                cc_fields: this.cc_fields,
                bcc_fields: this.bcc_fields,
                subject: this.subject,
                attachment_template: null,
                attachment_encrypt_file: this.attachment_encrypt_file,
                attachment_open_password: this.attachment_open_password,
                attachment_restrict_permissions: this.attachment_restrict_permissions,
                attachment_permission_password: this.attachment_permission_password,
                attachment_restrict_printing: this.attachment_restrict_printing,
                attachment_restrict_changes: this.attachment_restrict_changes,
                attachment_enable_content_copying: this.attachment_enable_content_copying,
                message_body: this.message_body,
                update_date_fields: this.update_date_fields,
                response_date_reference: this.response_date_reference,
                response_days: this.response_days,
                response_date: this.response_date,
            }),
        }
    },
    created() {
        this.ADDRESS_FIELDS = MessageEmailFieldEnum
        this.DATE_FIELDS = MessageUpdateDateFieldEnum
        this.RESPONSE_DATE_REFERENCE_ENUM = ResponseDateReferenceEnum
        this.PDF_CHANGE_PERMISSION_ENUM = PdfChangePermissionEnum
        this.PDF_PRINT_PERMISSION_ENUM = PdfPrintPermissionEnum
    },
    methods: {
        submit() {
            if (this.id == null) {
                this.form.post(this.route('events.messages.store', [this.eventInfo.id]))
            } else {
                this.form.post(this.route('messages.update', this.id))
            }
        },
        destroy() {
            if (confirm('Are you sure you want to delete this message?')) {
                this.$inertia.delete(this.route('messages.destroy', [this.id]))
            }
        },
    },
}
</script>
